export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAarjIs7Kw6NEBHP4yPmujCGBS6LBhrlNk",
    authDomain: "databi-solution.firebaseapp.com",
    projectId: "databi-solution",
    storageBucket: "databi-solution.firebasestorage.app",
    messagingSenderId: "169404237286",
    appId: "1:169404237286:web:89e1ff37c4f607342f8227",
    measurementId: "G-KX0LXZQ75F",
  },
  firebaseEnabled: true
};
